<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">

    <div id="containerVacaciones" class="col-12">
      <dx-load-panel #loadPanel shadingColor="rgba(231, 231, 231,0.4)" [position]="{ of: '#containerVacaciones' }"
        [visible]="loading" [showIndicator]="true" [showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
      </dx-load-panel>

      <div class="row">
        <div class="col-sm-12 col-lg-8 m-auto mt-3 mb-3 row" style="margin-bottom: 20px;" *ngIf="showSearchPanel">

          <div class="col-md col-lg col-xl">
            <app-company-selector dataSize="7" placeHolder="Empresas" [(ngModel)]="selectedCompany"
              [onlyConfigured]="true" [required]="true"></app-company-selector>
          </div>

          <div class="col-md col-lg col-xl">
            <app-employee-selector [companyCode]="selectedCompany" placeHolder="Empleados"
              [(selectedValue)]="selectedEmployee" [required]="true"></app-employee-selector>
          </div>

          <div class="col-md col-lg col-xl">
            <app-year-selector dataSize="7" placeHolder="Ejercicio" [required]="true" [(selectedValue)]="selectedYear">
            </app-year-selector>
          </div>
          <!-- Botón de búsqueda -->
          <div class="col-md-auto col-lg-auto col-xl-auto">
            <button class="btn btn-fill btn-primary float-right" (click)="onButtonBuscarClick()">Buscar</button>
          </div>
        </div>

        <div class="col-sm-12 col-lg-8 m-auto mt-3 mb-3 row" style="margin-bottom: 20px;" *ngIf="!showSearchPanel">
          <div class="col-md col-lg col-xl">
            <mat-form-field>
              <input matInput type="text" name="DescripcionEmpresa" placeholder="Empresa" [ngModel]="
                bolsaVacaciones && bolsaVacaciones.DescripcionEmpresa
                  " readonly />
            </mat-form-field>
          </div>

          <div class="col-md col-lg col-xl">
            <mat-form-field>
              <input matInput type="text" name="NombreTrabajador" placeholder="Trabajador" [ngModel]="
                bolsaVacaciones && bolsaVacaciones.NombreTrabajador
                  " readonly />
            </mat-form-field>
          </div>

          <div class="col-md col-lg col-xl">
            <mat-form-field>
              <input matInput type="text" name="Ejercicio" placeholder="Ejercicio" [ngModel]="
                bolsaVacaciones && bolsaVacaciones.Ejercicio
                  " readonly />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="row col-sm-12 col-lg-8 m-auto">
          <div class="col-md col-lg col-xl">
            <mat-form-field>
              <input matInput type="text" name="Convenio" placeholder="Convenio" [ngModel]="
              bolsaVacaciones && bolsaVacaciones.NombreConvenio" readonly />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-lg-4 ml-auto mt-3 mb-3">

          <legend>Bolsa de Vacaciones</legend>
          <div class="col-12">
            <mat-form-field>
              <input matInput type="text" name="DiasITAbsentismo" placeholder="Días de IT/Absentismo" [(ngModel)]="
                bolsaVacaciones && bolsaVacaciones.DiasITAbsentismo
                  " style="text-align: right" readonly />
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field>
              <input matInput type="text" name="ImporteBolsa" currencyMask placeholder="Importe BV" [(ngModel)]="
                bolsaVacaciones && bolsaVacaciones.ImporteBolsa
                  " readonly />
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field>
              <input matInput type="text" name="ImporteProporcional" currencyMask placeholder="Importe devengado BV"
                [ngModel]="importeBolsaDevengado" readonly />
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field>
              <input matInput type="text" name="ImporteProporcional" currencyMask placeholder="Parte proporcional BV"
                [(ngModel)]="
                  bolsaVacaciones &&
                  bolsaVacaciones.ImporteProporcional
                  " readonly />
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field>
              <input matInput type="text" name="ImporteCobrado" currencyMask placeholder="Cobrado BV" [(ngModel)]="
                bolsaVacaciones &&
                bolsaVacaciones.ImporteCobrado
                  " readonly />
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field>
              <input matInput type="text" name="Total" currencyMask placeholder="Total BV" [(ngModel)]="
                bolsaVacaciones && bolsaVacaciones.Importe
                  " readonly />
            </mat-form-field>
          </div>

        </div>
        <div class="col-sm-12 col-lg-4 mr-auto mt-3 mb-3">
          <form class="ng-untouched ng-pristine ng-valid" #formGenerarSolicitud="ngForm">

            <legend>Solicitar</legend>
            <!-- <div class="col-12">
                <mat-form-field>
                  <input matInput type="text" name="Dias" placeholder="Días" [(ngModel)]="solicitud.Dias" required/>
                </mat-form-field>
              </div> -->
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="Importe" currencyMask placeholder="Importe"
                  [(ngModel)]="solicitud.Importe" required />
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field>
                <input matInput [matDatepicker]="pickerFechaEstimadaDesde" [(ngModel)]="solicitud.FechaSolicitud"
                  [ngModelOptions]="{updateOn: 'blur'}" name="FechaSolicitud" (click)="pickerFechaEstimadaDesde.open()"
                  placeholder="Fecha" required />
                <mat-datepicker-toggle matSuffix [for]="pickerFechaEstimadaDesde"></mat-datepicker-toggle>
                <mat-datepicker #pickerFechaEstimadaDesde></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-12">
              <mat-form-field>
                <mat-select name="Destino" placeholder="Destino" [(ngModel)]="solicitud.Destino" required>
                  <mat-option *ngFor="let destino of tipoDestino" [value]="destino.value">
                    {{ destino.text }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-12" *ngIf="isAdvanceSelected()">
              <mat-form-field>
                <mat-select name="A3LExtraPayId" placeholder="Paga Extra" [(ngModel)]="solicitud.A3LExtraPaymentId" required>
                  <mat-option *ngFor="let pagaExtra of pagasExtras" [value]="pagaExtra.extraPayID">
                    {{ pagaExtra.extraPayName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="Observaciones" placeholder="Observaciones"
                  [(ngModel)]="solicitud.Observaciones" />
              </mat-form-field>
            </div>

            <div class="col-12">
              <button class="btn btn-fill btn-success float-right"
                [disabled]="disableButtonSolicitar(formGenerarSolicitud) || loading" type="button"
                (click)="onButtonSolicitarClick()">
                Solicitar
              </button>
            </div>

          </form>
        </div>
      </div>


      <div class="row">
        <div class="col-lg-8 col-sm-6  ml-auto mr-auto mt-3 mb-3">

          <legend>Solicitudes realizadas</legend>
          <dx-data-grid id="gridContainer" [dataSource]="solicitudes">
            <dxo-search-panel [visible]="false"></dxo-search-panel>
            <dxo-group-panel [visible]="false"></dxo-group-panel>
            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

            <!-- Definición de las columnas -->

            <dxi-column dataField="FechaSolicitud" caption="Fecha" dataType="date" alignment="left" format="dd/MM/yyyy">
            </dxi-column>
            <!-- <dxi-column dataField="DescripcionEmpresa" caption="Tipo"> </dxi-column> -->

            <!-- <dxi-column dataField="Dias" caption="Días"> </dxi-column> -->

            <dxi-column dataField="Destino" caption="Destino">
              <dxo-lookup [dataSource]="tipoDestino" valueExpr="value" displayExpr="text">
              </dxo-lookup>
            </dxi-column>

            <dxi-column dataField="Importe" caption="Importe">
              <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>

            <!-- <dxi-column dataField="CodigoImputacion" caption="Estado"> </dxi-column> -->
            <dxi-column dataField="Observaciones" caption="Observaciones">
            </dxi-column>

            <dxo-summary>
              <dxi-total-item column="FechaSolicitud" summaryType="count"> </dxi-total-item>
              <dxi-total-item column="Importe" summaryType="sum" [valueFormat]="{ type: 'currency', precision: 2 }">
              </dxi-total-item>
            </dxo-summary>
          </dx-data-grid>
        </div>

      </div>
      <div class="row">
        <div class="col-lg-4 col-sm-6 ml-auto mt-5 mb-3">

          <legend>Anticipos</legend>

          <dx-data-grid id="gridContainer" [dataSource]="anticipos">
            <dxo-search-panel [visible]="false"></dxo-search-panel>
            <dxo-group-panel [visible]="false"></dxo-group-panel>
            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

            <!-- Definición de las columnas -->

            <!-- <dxi-column dataField="conceptCode" caption="Concepto"> </dxi-column> -->
            <dxi-column dataField="date" caption="Fecha" dataType="date" alignment="left"
              format="dd/MM/yyyy"></dxi-column>
              <dxi-column dataField="extraPaymentSources" caption="Paga extra" [calculateCellValue]="getFirstExtraPayment"></dxi-column>
              <dxi-column dataField="totalAmount" caption="Importe">
              <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>

            <!-- <dxi-column dataField="CodigoImputacion" caption="Estado"> </dxi-column> -->
            <!-- <dxi-column dataField="Observaciones" caption="Observaciones">
          </dxi-column> -->
            <dxo-summary>
              <dxi-total-item column="date" summaryType="count"> </dxi-total-item>
              <dxi-total-item column="totalAmount" summaryType="sum" [valueFormat]="{ type: 'currency', precision: 2 }">
              </dxi-total-item>
            </dxo-summary>
          </dx-data-grid>

        </div>
        <div class="col-lg-4 col-sm-6 mr-auto mt-5 mb-3">

          <legend>Conceptos Variables</legend>

          <dx-data-grid id="gridContainer" [dataSource]="conceptosCreados.pageData">
            <dxo-search-panel [visible]="false"></dxo-search-panel>
            <dxo-group-panel [visible]="false"></dxo-group-panel>
            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

            <!-- Definición de las columnas -->

            <dxi-column dataField="conceptCode" caption="Concepto"> </dxi-column>
            <dxi-column dataField="collectionDate" caption="Fecha" dataType="date" alignment="right"
              format="dd/MM/yyyy"></dxi-column>
            <dxi-column dataField="amount" caption="Importe">
              <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>

            <!-- <dxi-column dataField="CodigoImputacion" caption="Estado"> </dxi-column> -->
            <!-- <dxi-column dataField="Observaciones" caption="Observaciones">
        </dxi-column> -->
            <dxo-summary>
              <dxi-total-item column="conceptCode" summaryType="count"> </dxi-total-item>
              <dxi-total-item column="amount" summaryType="sum" valueFormat="currency" [valueFormat]="{ type: 'currency', precision: 2 }">
              </dxi-total-item>
            </dxo-summary>
          </dx-data-grid>

        </div>
      </div>
    </div>
    <!-- Botonera -->
    <div class="row">
      <div class="col-md-12">
        <div class="form-group form-button">
          <a class="btn btn-fill btn-outline-white float-right" (click)="goBack()">Volver</a>
        </div>
      </div>
    </div>
  </app-generic-panel>
</app-generic-container>
